import { combineReducers } from "redux";

import { User } from 'firebase';

import { RootAction } from "../types";

function loginError(state: string | null = null, action: RootAction): string | null {
    switch (action.type) {
    case 'LOG_IN_REQUEST':
    case 'LOG_IN_SUCCESS':
        return null;
    case 'LOG_IN_FAILURE':
        return action.payload.message;
    default:
        return state;
    }
}

function isLoading(state: boolean = false, action: RootAction): boolean {
    switch (action.type) {
    case 'LOG_IN_REQUEST':
        return true;
    case 'LOG_IN_SUCCESS':
    case 'LOG_IN_FAILURE':
        return false;
    default:
        return state;
    }
}

function currentUser(state: User | null = null, action: RootAction): User | null {
    switch (action.type) {
    case 'AUTH_STATE_CHANGED':
        return action.payload;
    default:
        return state;
    }
}

export const authReducer = combineReducers({
    currentUser,
    isLoading,
    loginError,
});

export default authReducer;



// WEBPACK FOOTER //
// ./src/reducers/authReducer.ts